import React, { ReactNode } from "react"

import { Button, Chip, Grid } from "@material-ui/core"

import { Forum } from "@material-ui/icons"
import PeopleOnRocketSVGIcon from "@/assets/images/illustrations/people_on_rocket.svg"
import { StarRateIcon } from "@/assets/icons"
import { Kanban as BoardIcon } from "lucide-react"

import { Text, themeColors } from "letalkui"

import Breadcrumb from "@/components/BreadcrumbNew"
import { AlertContainer } from "@/components"

import { whatsappLinks } from "@/utils/link"

import { useGlobalStateStore } from "@/store/GlobalState"
import { ErrorType } from "@/hooks/useValidation"

import ErrorHandlerService from "@/services/ErrorHandler"

import useStyles from "@/pages/Admin/Boards/UpsellBoardPage/styles"
import Axios from "axios"

const UpsellBoardPage: React.FC = () => {
	const globalStateStore = useGlobalStateStore()

	const instanceId = globalStateStore.instance.instance_id
	const planName = globalStateStore.instance.subscriptionData?.plan_name
	const currentChannelType = globalStateStore.currentChannel?.channelType

	const classes = useStyles()

	const DIFERENTIALS: Array<{
		title: string
		content: string
		icon: ReactNode
	}> = [{
		title: "Integração com Inbox",
		content: "Transforme conversas em oportunidades com 1 clique direto do seu Inbox.",
		icon: <Forum style={{ color: themeColors.getPrimaryColor(), width: "24px", height: "24px" }} />
	},
	{
		title: "CRM Visual",
		content: "Organize seus atendimentos em colunas personalizáveis (como “Novo lead”, “Negociação”, “Fechou”) e acompanhe cada etapa com clareza.",
		icon: <BoardIcon style={{ color: themeColors.getPrimaryColor(), width: "24px", height: "24px" }} />
	}]

	const handleRedirectToWhatsAppConsultant = () => {
		window.open(whatsappLinks.sendMessageToAcquireFunnelModule, "_blank")
	}

	const handleSendUserPlanDataToMake = async () => {
		try {
			await Axios.post("https://hook.us2.make.com/bwazcwn3ipoi9f6crr241x2mit5oqs6b", {
				instanceId,
				planName: planName,
				channelType: currentChannelType
			})
		} catch (error) {
			ErrorHandlerService.handle(error as ErrorType)
		}
	}

	return (
		<Grid
			container
			direction="column"
			spacing={6}
		>
			<Grid item>
				<Grid container direction="column" spacing={3}>
					<Grid item>
						<Breadcrumb
							data={[
								{ name: "Funil de Vendas", pathname: "/admin/funnel" }
							]}
						/>
					</Grid>

					<Grid item xs={12}>
						<Grid container direction="column" spacing={3}>
							<Grid item xs={12}>
								<Chip
									size="medium"
									label="MÓDULO ADICIONAL"
									className={classes.new_module}
									icon={<StarRateIcon />}
								/>
							</Grid>

							<Grid item xs={12}>
								<Grid container spacing={8}>
									<Grid item xs={12}>
										<Grid container spacing={2}>
											<Grid item>
												<Text.Title
													type="h1"
													fontWeight="semibold"
													color={themeColors.getActionColor()}
												>
													🔒 Este recurso faz parte do módulo Funil de Vendas
												</Text.Title>
											</Grid>
											<Grid item>
												<Text.Body
													type="large"
													fontWeight="regular"
													color={themeColors.getTextColor()}
												>
													Você tentou acessar uma funcionalidade exclusiva do módulo Funil de Vendas, que não está disponível no seu plano atual.
												</Text.Body>
											</Grid>
											<Grid item xs={12}>
												<AlertContainer
													alertType="info"
												>
													<Text.Body
														type="default"
														fontWeight="semibold"
														color={themeColors.getPrimaryColor()}
													>
														Esse módulo é ideal para transformar conversas no WhatsApp em oportunidades reais com organização e eficiência
													</Text.Body>
												</AlertContainer>
											</Grid>
										</Grid>
									</Grid>
									<Grid item xs={12}>
										<Grid container>
											<Grid item xs={6}>
												<Grid container direction="column" spacing={4}>
													<Grid item>
														<Grid container spacing={2}>
															{DIFERENTIALS.map((DIFERENTIAL, index) => {
																return (
																	<Grid
																		item
																		xs={12}
																		key={index}
																	>
																		<Grid
																			container
																			direction="column"
																			spacing={2}
																		>
																			<Grid item>
																				<Grid container spacing={2}>
																					<Grid item>
																						{DIFERENTIAL.icon}
																					</Grid>

																					<Grid item>
																						<Text.Body
																							type="large"
																							fontWeight="semibold"
																							color={themeColors.getTextColor()}
																						>
																							{DIFERENTIAL.title}
																						</Text.Body>
																					</Grid>
																				</Grid>
																			</Grid>
																			<Grid item>
																				<Text.Body
																					type="large"
																					fontWeight="regular"
																					color={themeColors.getTextColor()}
																				>
																					{DIFERENTIAL.content}
																				</Text.Body>
																			</Grid>
																		</Grid>
																	</Grid>
																)
															})}

															<Grid item>
																<Text.Body
																	type="large"
																	fontWeight="regular"
																	color={themeColors.getTextColor()}
																>
																	Resumindo: você ganha organização, automação e mais controle sobre suas vendas — direto no WhatsApp.
																</Text.Body>
															</Grid>
														</Grid>
													</Grid>
													<Grid item>
														<Button
															className={classes.button}
															variant="contained"
															onClick={() => {
																handleRedirectToWhatsAppConsultant()
																handleSendUserPlanDataToMake()
															}}
														>
															<Text.Body
																type="large"
																fontWeight="bold"
																color={themeColors.colors.base.white}
															>
																Falar com um consultor
															</Text.Body>
														</Button>
													</Grid>
												</Grid>
											</Grid>
											<Grid item xs={6}>
												<Grid container justifyContent="center" alignContent="flex-start">
													<img src={PeopleOnRocketSVGIcon}/>
												</Grid>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default UpsellBoardPage
